const displayToggle = (button, dropdown, className, body) => {
  const buttonEl = document.querySelector(button)
  const dropdownEl = document.querySelector(dropdown)
  const bodyEl = document.querySelector(body)

  if (!buttonEl || !dropdownEl || !className) {
    return null
  }

  buttonEl.addEventListener('click', () => {
    const allToggleBtns = document.querySelectorAll(
      '.is-active[data-btn-toggle]',
    )

    allToggleBtns &&
      allToggleBtns.forEach((elm) => {
        elm.classList.remove('is-active')
        elm.nextElementSibling.classList.add('hidden')
      })

    buttonEl.classList.toggle('is-active')

    if (bodyEl) bodyEl.classList.toggle('mobile-overflow')

    dropdownEl.classList.toggle(className)
  })
}

export default displayToggle
